<!--点击加载更多-->
<template>

  <div class="loading_more_index" >
    <div class="loading_more_con"
         :style="{'margin':margin}"
         @click="handleLoad">
      <!--    loading-->
      <template v-if="loading">
        <van-loading type="spinner" size="24px" />
      </template>
      <template v-else>
        <!-- error-->
        <template v-if="error">
            <span>
              {{ errorText }}
            </span>
        </template>

        <!-- finished-->
        <template v-if="finished">
            <span>
              {{ finishedText }}
            </span>
        </template>

        <template v-if="!(finished || error)">
            <span>
              {{ loadingMoreText }}
            </span>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LoadingMore',
  components: {
  },
  props: {
    loading:{
      type: Boolean,
      default: false
    },
    loadingMoreText: {
      type: String,
      default: '加载更多...'
    },
    finished: {
      type: Boolean,
      default: false
    },
    finishedText:{
      type: String,
      default: '没有更多了'
    },
    error:{ //:error.sync
      type: Boolean,
      default: false
    },
    errorText:{
      type: String,
      default: '请求失败，点击重新加载'
    },
    load:{
      type: Function,
      default: ()=> {}
    },
    margin:{
      type:String,
      default: '0 12px'
    }
  },

  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ]),
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleLoad(){
      if(!this.loading && !this.finished){
        this.load();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading_more_index{
    width: 100%;
    display: block;
    text-align: center;
    cursor: pointer;
    margin-top: 15px;
    text-shadow: 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, 0.3);
    .loading_more_con{
      font-size: 12px;
      background: #faeeee;
      color: #888;
      padding: 8px 0;
      margin: 0 12px;
      border-radius: 5px;
    }
  }
</style>
